import { ConversationItem } from '@app/models'

import { mergeMapByKey } from '@lib/utils'

import { CONVERSATIONS_LIST_SIZE } from '../constants'
import { ChatState, InitialStatePayload } from '../types'

export const onFetchInitialStateSuccess = (
  state: ChatState,
  payload: InitialStatePayload
): ChatState => {
  const { acsChatParticipantId, acsChatToken, participantIds, nextPageCursor } =
    payload

  const listings = mergeMapByKey(payload.listings, state.listings, 'id')
  const accounts = mergeMapByKey(payload.accounts, state.accounts, 'id')
  const conversations = payload.conversations.reduce<
    Record<number, ConversationItem>
  >((acc, item) => {
    return {
      ...acc,
      [item.id]: item,
    }
  }, {})

  const allConversationsLoaded =
    payload.conversations.length < CONVERSATIONS_LIST_SIZE

  return {
    ...state,
    acsChatParticipantId,
    acsChatToken,
    conversations,
    listings,
    participantIds,
    nextPageCursor,
    accounts,
    unreadList: payload.unreadList,
    unreadTotal: payload.unreadTotal,
    allConversationsLoaded,
    hasSpam: payload.hasSpam,
    fetching: 'SUCCEED',
  }
}
